module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hd-wap-share"
  }, [(_vm.id != '' && _vm.id != undefined && _vm.id != null) ? [_c('video', {
    ref: "video",
    attrs: {
      "src": _vm.obj.url,
      "controls": "controls",
      "id": "video",
      "x-webkit-airplay": "allow",
      "muted": "",
      "playsinline": ""
    },
    domProps: {
      "muted": true
    }
  }, [_vm._v("\n      您的浏览器不支持 video 标签。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "title f16"
  }, [_vm._v(_vm._s(_vm.obj.name))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "code"
  }, [_c('img', {
    attrs: {
      "src": _vm.obj.qrUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "f13"
  }, [_vm._v("观看完整视频")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playOver),
      expression: "playOver"
    }],
    staticClass: "tip",
    on: {
      "click": _vm.resetVideo
    }
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _vm._m(2)])] : [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50%"
    }
  }, [_vm._v("您的链接缺少课时信息,请确认后重试")])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bt"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/share/image_text.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "f13"
  }, [_vm._v("长按二维码,下载"), _c('span', {
    staticStyle: {
      "color": "#0193e6"
    }
  }, [_vm._v("海渡职校")]), _vm._v("APP")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "f16"
  }, [_vm._v("试看结束")]), _vm._v(" "), _c('p', {
    staticClass: "f16"
  }, [_vm._v("请下载海渡职校APP继续观看")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a9e9789","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share.vue
// module id = 318
// module chunks = 1